export const POSTCODE_REGEX =
    /^\s*([A-Z]{1,2}[0-9][0-9A-Z]?)\s*([0-9][A-Z]{2})\s*$/i;

export const postcodeToOutcode = (postcode: string): string | null => {
    const matches = postcode.match(POSTCODE_REGEX);

    return matches ? matches[1].toUpperCase() : null;
};

export const formatPostcode = (postcode: string): string => {
    const matches = postcode.match(POSTCODE_REGEX);

    if (!matches) return postcode;

    return `${matches[1].toUpperCase()} ${matches[2].toUpperCase()}`;
};
